module.exports = __webpack_public_path__ + "img/681cc2b.png";